import { useCallback } from "react";
import { Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { AppConstant } from "../../redux/reducers";
import UnlinkAvatarCollapse from "../avatar/UnlinkAvatarCollapse";
import { MLeftButton } from "../commons/MIcon";
import LangCollapse from "../langs/LangCollapse";

const SettingSidebar = ({ show }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handlerClose = useCallback(() => {
    dispatch({ type: AppConstant.SET_SHOW_SETTING, show: false });
  }, [dispatch]);

  return <>
    <Offcanvas
      show={show}
      onHide={handlerClose}
      placement="end"
      className="w-100"
      style={{
        maxWidth: 600,
        borderLeft: "none",
        borderRight: "none",
      }}
    >
      <Offcanvas.Header className="gap-3" style={{ boxSizing: "content-box" }}>
        <Offcanvas.Title>
          <MLeftButton size={40} onClick={handlerClose} />
        </Offcanvas.Title>
        <Offcanvas.Title className="flex-fill">
          {t("Setting")}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="bg-content_body d-flex flex-column gap-3 user-select-none">
        <LangCollapse />
        <UnlinkAvatarCollapse />
      </Offcanvas.Body>
    </Offcanvas>
  </>
};

const mapState = (state) => {
  const show = state.AppReducer.show.setting;
  return { show };
};

const mapDispatch = dispatch => ({

})

export default connect(mapState, mapDispatch)(SettingSidebar);
